import uniq from "lodash/uniq";
// export const uniq = array => [...new Set(array)];
export var unique = uniq;